module.exports = {"apiUrl":"https://sietest2.sie.se","isProduction":true,"isStaging":false,"isDev":false};